import { createTheme } from "@mui/material/styles";
import palette from "../constants/palette";

const getDesignTokens = (mode) => ({
  palette: {
    mode, // this sets the theme mode
    primary: {
      main: mode === "light" ? palette.grayDark : palette.white,
    },
    secondary: {
      main: mode === "light" ? palette.red : palette.red,
    },
    background: {
      default: mode === "light" ? palette.grayLight : palette.grayDarker,
      primary: mode === "light" ? palette.grayLight : palette.grayDarker,
      secondary: mode === "light" ? palette.grayLight : palette.grayDark,
      paper: mode === "light" ? palette.white : palette.grayDark,
      scrollbar: mode === "light" ? palette.white : "rgba(0, 0, 0, 0)",
    },
    link: {
      main: mode === "light" ? "#d32f2f" : "#e57373",
      hovered: mode === "light" ? "#b71c1c" : "#ff5252",
    },
    text: {
      primary: mode === "light" ? palette.blackRGBA(87) : "#E0E0E0",
      secondary:
        mode === "light" ? palette.blackRGBA(54) : palette.whiteRGBA(70),
      disabled:
        mode === "light" ? palette.blackRGBA(38) : palette.whiteRGBA(50),
    },
    action: {
      active: palette.red,
    },
  },
});

export const createMuiTheme = (mode) =>
  createTheme({
    ...getDesignTokens(mode),
    typography: {
      fontFamily: `"Montserrat", sans-serif`,
    },
  });
